export const NOVA_DM_ID = 'nova';

export type NovaPieceKind = 'invoice' | 'estimate' | 'credit_note' | 'time';

export type NovaTurn = {
  reply: string;
  creation: boolean;
  kind: NovaPieceKind | null;
};

const QUIT = /quitte|sortir|ferme le mode|exit/i;
const ENTER = /mode cr[eé]ation|passe en cr[eé]ation/i;

function kindOf(text: string): NovaPieceKind | null {
  if (/avoir/i.test(text)) return 'credit_note';
  if (/feuille de temps|prestation|\btemps\b/i.test(text)) return 'time';
  if (/devis/i.test(text)) return 'estimate';
  if (/facture/i.test(text)) return 'invoice';
  return null;
}

const KIND_LABEL: Record<NovaPieceKind, string> = {
  invoice: 'la facture',
  estimate: 'le devis',
  credit_note: "l'avoir",
  time: 'la prestation',
};

export function interpretNovaTurn(
  text: string,
  state: { creation: boolean; kind: NovaPieceKind | null },
): NovaTurn {
  const raw = text.trim();
  if (!raw) {
    return { reply: '', creation: state.creation, kind: state.kind };
  }
  if (state.creation && QUIT.test(raw)) {
    return {
      reply: 'Mode création fermé.',
      creation: false,
      kind: null,
    };
  }
  const asked = kindOf(raw);
  const enter = ENTER.test(raw) || (asked != null && !state.creation && /cr[eé]e|nouveau|nouvelle|ouvre/i.test(raw));
  if (enter || (state.creation && asked)) {
    const kind = asked ?? state.kind ?? 'invoice';
    return {
      reply: `Mode création. Je prépare ${KIND_LABEL[kind]}. Donne-moi le dossier, le client et les lignes.`,
      creation: true,
      kind,
    };
  }
  if (state.creation) {
    return {
      reply: `Je suis sur ${KIND_LABEL[state.kind ?? 'invoice']}. Précise le dossier, le client, ou les lignes.`,
      creation: true,
      kind: state.kind,
    };
  }
  return {
    reply: 'Dis « mode création » pour ouvrir une facture, un devis, un avoir ou une prestation.',
    creation: false,
    kind: null,
  };
}
